import axios from "axios";

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "https://tstatsapi.stats-insight.com/"
      : "https://tstatsapi.stats-insight.com/",
  withCredentials: true,
});

export const api_authUserLogin = async (payload) => {
  console.log("Get User Login");
  try {
    const { data } = await instance.post("usr/login", payload);
    console.log("login data: ", data);
    // 如果遇到驗證問題先註解這行
    if (data.status === undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    console.error(err);
    return { status: "error", message: err.message };
  }
};

export const api_getFilterResult = async (payload, cookies) => {
  console.log("Get Filter Result");
  try {
    const { data } = await instance.post("ballsStat/getFilterResult", payload, {
      headers: {
        "Content-Type": "application/json",
        Cookie: cookies,
      },
    });
    // if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getFilterLeagueData = async () => {
  console.log("Get Filter League Data");
  try {
    const data = await instance.get("ballsStat/getFilterLeagueData");
    if (data.status === undefined) throw Error(data.message);
    return { status: "success", data: data.data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getPitcherLeaderboardData = async (payload) => {
  console.log("Get Pitcher Leaderboard");
  try {
    const { data } = await instance.post(
      "/lead/getPitcherLeaderBoardData",
      payload
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getBatterLeaderboardData = async (payload) => {
  console.log("Get Batter Leaderboard");
  try {
    const { data } = await instance.post(
      "/lead/getBatterLeaderBoardData",
      payload
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getTeamBattingLeaderboardData = async (payload) => {
  console.log("Get Team Batting Leaderboard");
  try {
    const { data } = await instance.post(
      "/lead/getTeamBattingLeaderBoardData",
      payload
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getTeamPitchingLeaderboardData = async (payload) => {
  console.log("Get Team Pitching Leaderboard");
  try {
    const { data } = await instance.post(
      "/lead/getTeamPitchingLeaderBoardData",
      payload
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_get2021SinglePlayerStat = async (payload) => {
  console.log("Get 2021 Single Player BallsStat");
  try {
    const { data } = await instance.post(
      "/ballsStat/get2021SinglePlayerStat",
      payload
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_get2022SinglePlayerStat = async (payload) => {
  console.log("Get 2022 Single Player BallsStat");
  try {
    const { data } = await instance.post(
      "/ballsStat/get2022SinglePlayerStat",
      payload
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getPitcherPR = async (payload) => {
  console.log("Get Pitcher PR");
  try {
    const { data } = await instance.post("/pr/getPitcherPRData", payload);
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getBatterPR = async (payload) => {
  console.log("Get Batter PR");
  try {
    const { data } = await instance.post("/pr/getBatterPRData", payload);
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getPitcherStat = async (payload) => {
  console.log("Get Pitcher Stat");
  try {
    const { data } = await instance.post("/stat/getPitcherStat", payload);
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getBatterStat = async (payload) => {
  console.log("Get Batter Stat");
  try {
    const { data } = await instance.post("/stat/getBatterStat", payload);
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getReportData = async (dest) => {
  console.log("Get Report Data");
  try {
    const { data } = await instance.get(`/report/${dest}`);
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getBatterScoreLogs = async (payload) => {
  console.log("Get Batter Score Logs");
  try {
    const { data } = await instance.post("/stat/getBatterScoreLogs", payload);
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getCatcherEdgePitches = async (payload) => {
  console.log("Get Catcher Edge Pitches");
  try {
    const { data } = await instance.post(
      "/ballsStat/getCatcherEdgePitches",
      payload
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getVideoInitRecord = async (payload) => {
  console.log("Get Init Record");
  try {
    const { data } = await instance.post("/ballsStat/getInitRecord", payload);
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getVideoCorrespondingRecord = async (payload) => {
  console.log("Get Matching Record");
  try {
    const { data } = await instance.post(
      "/ballsStat/getMatchingRecord",
      payload
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getVideoSignedURL = async (payload) => {
  console.log("Get Video URL");
  try {
    const {
      data: { url },
    } = await instance.post("/video/getVideoURL", payload);
    // console.log("url:", url)
    return url;
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getPlateIDRecord = async (payload) => {
  console.log("Get Plate ID Record");
  try {
    const { data } = await instance.post(
      "/ballsStat/getPlateIDRecord",
      payload
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getVideoListData = async () => {
  const cookie = document.cookie;
  console.log("cookie: ", cookie);
  console.log("Get Video List");
  try {
    const { data } = await instance.get("/ballsStat/getVideoListData", {
      headers: {
        Cookie: document.cookie,
      },
    });
    console.log("data res: ", data);
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getPlayerRoster = async () => {
  console.log("Get Player Roster");
  try {
    const { data } = await instance.get("/ballsStat/getPlayerRoster");
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getSinglePlayerInfo = async (payload) => {
  console.log("Get Player Roster");
  try {
    const { data } = await instance.post(
      "/ballsStat/getSinglePlayerPersonInfo",
      payload
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getPlayerHeadtoHeadData = async (payload) => {
  console.log("Get Player H2H Data");
  try {
    const { data } = await instance.post("/stat/getHeadtoHeadStats", payload);
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getUmpireData = async (payload) => {
  console.log("Get Umpire Data");
  try {
    const { data } = await instance.post("/stat/getUmpireData", payload);
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getPlayerGameLogs = async (payload) => {
  console.log("Get Player Game Log");
  try {
    const { data } = await instance.post("/stat/getPlayerLogs", payload);
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getBatterDisciplineLeaderboardData = async (payload) => {
  console.log("Get Discipline Leaderboard Data");
  try {
    const { data } = await instance.post(
      "/ballsStat/getDisciplineLeaderboardData",
      { ...payload, type: "Batter" }
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getPitcherDisciplineLeaderboardData = async (payload) => {
  console.log("Get Discipline Leaderboard Data");
  try {
    const { data } = await instance.post(
      "/ballsStat/getDisciplineLeaderboardData",
      { ...payload, type: "Pitcher" }
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getPlayerGameReportData = async (payload) => {
  console.log("Get Player Game Report Data");
  try {
    const { data } = await instance.post(
      "/ballsStat/getGameReportData",
      payload
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getUmpireGameMappingData = async () => {
  console.log("Get Umpire Game Mapping Data");
  try {
    const { data } = await instance.get("/ballsStat/getUmpireGameMapping");
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getBatterAnnualStat = async (payload) => {
  console.log("Get Batter Annual Stat");
  try {
    const { data } = await instance.post("/stat/getBatterAnnualStat", payload);
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getPitcherAnnualStat = async (payload) => {
  console.log("Get Pitcher Annual Stat");
  try {
    const { data } = await instance.post("/stat/getPitcherAnnualStat", payload);
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getPlayerPersonalInfo = async (payload) => {
  console.log("Get Player Personal Info");
  try {
    const { data } = await instance.post(
      "/stat/getPlayerPersonalInfo",
      payload
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export default instance;
